export const NON_INVITED_CATEGORIES = [
	{ value: 'Pidilite Employee', label: 'Pidilite Employee' },
	{ value: 'WSS', label: 'WSS' },
	{ value: 'Dealer', label: 'Dealer' },
	{ value: 'Helper/Junior Staff', label: 'Helper/Junior Staff' },
];

export const NON_INVITED_DESIGNATION_LIST = [
	{ value: 'RSM/ZSM', label: 'RSM/ZSM' },
	{ value: 'BM/ASM', label: 'BM/ASM' },
	{ value: 'RBDM/RMDM/AMMD/CSFM', label: 'RBDM/RMDM/AMMD/CSFM' },
	{ value: 'TSI', label: 'TSI' },
	{ value: 'HO Manager', label: 'HO Manager' },
	{ value: 'Promoter', label: 'Promoter' },
	{ value: 'CMDI', label: 'CMDI' },
];

export const MEETING_TODAY_MEETING = 'MAR(Today Meeting)';
export const MEETING_CONDUCTED_STATUS = 'List Of Meeting Conducted';
export const COMPLETED_MEETING_STATUS = 'Completed Meeting';

export const ONE_HOUR_MS = 60 * 60 * 1000;

export const MEETING_STATUS_OPTIONS = [
	{ value: 'Scheduled Meeting', label: 'Scheduled Meeting' },
	{ value: 'MAR(Today Meeting)', label: 'MAR(Today Meeting)' },
	{ value: 'Completed Meeting', label: 'Completed Meeting' },
	{ value: 'List Of Meeting Conducted', label: 'List Of Meeting Conducted' },
	{ value: 'All', label: 'All' },
];

//One to One Meeting
export const ONE_TO_ONE_MEETING_CATEGORY_OPTIONS = [
	{ value: 'End User', label: 'End User', iconClass: 'icon-user' },
	{ value: 'Dealer', label: 'Dealer', iconClass: 'icon-dealer' },
	{ value: 'Site Supervisor', label: 'Site Supervisor', iconClass: 'icon-site-supervisor' },
	{ value: 'Builder', label: 'Builder', iconClass: 'icon-builder' },
	{ value: 'Influencer', label: 'Influencer', iconClass: 'icon-builder1' },
];

export const TYPE_OF_DISCUSSION_OPTIONS = [
	{
		value: 'Product Demo',
		label: 'Product Demo',
		iconClass: 'icon-question-circle',
		redirectTo: '/product-discussion-demo',
	},
	{
		value: 'Scheme Discussion',
		label: 'Scheme Discussion',
		iconClass: 'icon-scheme-discussion',
		redirectTo: '/scheme-discussion',
	},
	{
		value: 'Complaint Handling',
		label: 'Complaint Handling',
		iconClass: 'icon-error-tringle',
		redirectTo: '/complaint-handling',
	},
	{
		value: 'Relationship Building',
		label: 'Relationship Building',
		iconClass: 'icon-heart',
		redirectTo: '/relationship-building',
	},
	{ value: 'Market Feedback', label: 'Market Feedback', iconClass: 'icon-feedback', redirectTo: '/market-feedback' },
	{
		value: 'Lead Generation',
		label: 'Lead Generation',
		iconClass: 'icon-lead-generation',
		redirectTo: '/lead-generation',
	},
];

/** Shown when business_capture_c is 0 or missing (null). */
export const CLOSE_SITE_ZERO_CAPTURE_FEEDBACK_OPTIONS = [
	{ label: 'Customer has postponed or is not interested', value: 'Customer has postponed or is not interested' },
	{ label: 'Lost to competition due to price', value: 'Lost to competition due to price' },
	{ label: 'Product Gap – Range not available', value: 'Product Gap – Range not available' },
	{
		label: 'Service Gap – warranty / features not available',
		value: 'Service Gap – warranty / features not available',
	},
	{ label: 'Weak follow-up from Dr Fixit or User', value: 'Weak follow-up from Dr Fixit or User' },
];

/** Shown when capture % is above 0% and below 80% of business_potential_c. */
export const CLOSE_SITE_PARTIAL_CAPTURE_FEEDBACK_OPTIONS = [
	{ label: 'Customer downgraded to Lower Product', value: 'Customer downgraded to Lower Product' },
	{ label: 'Actual Area was less than estimated', value: 'Actual Area was less than estimated' },
	{ label: 'Customer did not purchase ancillary Products', value: 'Customer did not purchase ancillary Products' },
];
